import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import SortOption from './sort-option.js'

const createOption = ({fieldName, order, labels}) => ({
  fieldName,
  order,
  label: labels[order]
})

const SearchSortOptions = ({search, onSelectOption, sortConfig}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const ORDER = config.get('ORDER')

  const _getSortOptions = () => {
    const sortFieldNames = Object.keys(sortConfig)

    return sortFieldNames
      .map(fieldName => [
        createOption({
          fieldName,
          order: ORDER.ASC,
          labels: sortConfig[fieldName].label
        }),
        createOption({
          fieldName,
          order: ORDER.DESC,
          labels: sortConfig[fieldName].label
        })
      ])
      .flat()
      .filter(field => field.label)
  }

  const _getIsChecked = ({sortBy, sortOrder}) => {
    return search.sortOrder === sortOrder && search.sortBy?.toLowerCase() === sortBy.toLowerCase()
  }

  const sortOptions = _getSortOptions()

  return (
    <ol className="mt-SearchSort-options">
      {sortOptions.map(({fieldName, order, label}) => (
        <SortOption
          key={label}
          label={i18n.t(label)}
          isChecked={_getIsChecked({sortBy: fieldName, sortOrder: order})}
          onSelectOption={() => onSelectOption({sortBy: fieldName, sortOrder: order})}
        />
      ))}
    </ol>
  )
}

SearchSortOptions.displayName = 'SearchSortOptions'
SearchSortOptions.propTypes = {
  search: PropTypes.object.isRequired,
  onSelectOption: PropTypes.func.isRequired,
  sortConfig: PropTypes.object.isRequired
}

export default SearchSortOptions
